<div class="modal-wrapper">
  <app-modal-header-common title="Pulses" [dialogRef]="dialogRef">
  </app-modal-header-common>

  <div class="modal-body">
    <app-pulse
      [pulsesList]="pulsesList"
      [projectId]="projectId"
      [card]="card"
      [isRisk]="isRisk"
      [activeTab]="activeTab"
      [showPreprocessed]="showPreprocessed"
    >
    </app-pulse>
  </div>

  <div class="modal-footer">
    <button mat-button mat-dialog-close color="primary" (click)="closeDialog()">
      Close
    </button>
  </div>
</div>
